import React from 'react';
import { SkeletonBlock } from '@one-thd/sui-atomic-components';

export function TableStatusPlaceholder() {
  return (
    <SkeletonBlock aspect="wide" height={8} />
  );
}
